import { getCloudinaryImageId } from '~/utils/cloudinaryImage';

import { FlatImageItem } from './types';

type LegacyImage = {
  id: string | number;
  order?: number;
  publicImageId?: string;
  id_cloudinary_external?: string;
  idCloudinaryExternal?: string;
  imageId?: string;
  idImage?: string;
  title?: string;
  description?: string;
  hidden?: boolean;
  is_hero?: boolean;
  filename?: string;
  urls?: Array<{
    url?: string;
  }>;
};

function getPublicImageId(image: LegacyImage) {
  return getCloudinaryImageId(image);
}

export function sortImagesByOrder<T extends { order?: number }>(images: Array<T>) {
  return [...images].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}

export function toFlatImageItem(image: LegacyImage): FlatImageItem {
  return {
    id: image.id,
    publicImageId: getPublicImageId(image),
    previewUrl: image.urls?.[0]?.url,
    order: image.order ?? 0,
    displayId: getPublicImageId(image) || String(image.id),
    filename: image.filename,
    description: image.title ?? image.description ?? '',
    descriptionEditable: true,
    isHero: image.is_hero ?? false,
    isHidden: image.hidden ?? false,
  };
}

export function mergeFlatItemsWithLegacy<T extends LegacyImage>(
  currentImages: Array<T>,
  items: Array<FlatImageItem>,
): Array<T> {
  return items.map((item) => {
    const existingImage = currentImages.find((image) => String(image.id) === String(item.id));
    const publicImageId = item.publicImageId || getPublicImageId(existingImage ?? { id: item.id });

    const nextImage = {
      ...(existingImage ?? {}),
      id: item.id,
      order: item.order,
      title: item.description,
      description: item.description,
      hidden: item.isHidden ?? false,
      is_hero: item.isHero ?? false,
      publicImageId,
      id_cloudinary_external: existingImage?.id_cloudinary_external ?? publicImageId,
      idCloudinaryExternal: existingImage?.idCloudinaryExternal ?? publicImageId,
      imageId: existingImage?.imageId ?? publicImageId,
      idImage: existingImage?.idImage ?? publicImageId,
      filename: item.filename ?? existingImage?.filename,
    };

    return nextImage as T;
  });
}
